import { InputSelectIcon } from './customIcons';

import type { OverWritable } from '../../@types/settings';

export const select: OverWritable = {
  MuiSelect: {
    defaultProps: {
      IconComponent: InputSelectIcon,
    },
  },
};
